export default "__VITE_ASSET__6c2f1f18__"